import { render, staticRenderFns } from "./StockRecallView.vue?vue&type=template&id=cd3ba170"
import script from "./StockRecallView.vue?vue&type=script&lang=js"
export * from "./StockRecallView.vue?vue&type=script&lang=js"
import style0 from "./StockRecallView.vue?vue&type=style&index=0&id=cd3ba170&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports